import React from 'react';
import Navbar from '../core/components/Navbar/Navbar';
import Footer from '../core/components/Footer/Footer';
import CSSLoader from './CSSLoader';

const BlogLayout = ({ children, userLogout }) => {

  return (
    <div className="blog-app" id="blog-app">
      <CSSLoader />
      <Navbar userLogout={userLogout} />
      <div className="blog">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default BlogLayout;

